import React from 'react'
import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom'
import BtnPrimary from '../../atom/btn-primary/index.tsx'
import { trackMarketingEvent } from '../../../helpers/analytics.ts'
import { normalizeLanguage, withLang } from '../../../utils/langPath.ts'
import './index.css'

interface Props {
	title?: string,
}

interface ReviewItem {
	name: string
	text: string
}

const Reviews: React.FC<Props> = ({
	title
}) => {
	const { t, i18n } = useTranslation('reviews')
	const { t: tCommon } = useTranslation()
	const navigate = useNavigate()
	const lang = normalizeLanguage(i18n.language)

	const displayTitle = title || t('title')
	const reviewItems = t('items', { returnObjects: true }) as ReviewItem[]

	const getReviewImage = (): string => {
		const viewportWidth = window.innerWidth
		if (viewportWidth <= 1024 && viewportWidth > 679) {
			return require('../../../assets/weddingCamera/reviews-image-tablet.png')
		}

		if (viewportWidth <= 679) {
			return require('../../../assets/weddingCamera/reviews-image.png')
		}

		return require('../../../assets/weddingCamera/reviews-image.png')
	}

	return (
		<section className='reviews-container'>
			<div className='reviews-content-container'>
				<div className='reviews-title-container'>
					<h2 className='reviews-container-title'>{displayTitle}</h2>
					<img className='reviews-image' src={getReviewImage()} alt={t('imageAlt')} />
				</div>

				<div className='scroll-view-review-container'>
					{Array.isArray(reviewItems) && reviewItems.map((review, index) => (
						<div className='review-item' key={index}>
							<p className='review-item-text'>{review.text}</p>
							<h3 className='review-item-title'>{review.name}</h3>
						</div>
					))}
				</div>
			</div>
			<div className='reviews-get-the-app-container'>
				<p className='reviews-get-the-app-text'>{t('joinCouples')}</p>
				<BtnPrimary className='reviews-get-the-app-btn' title={tCommon('buttons.secureMemories')} onPress={() => {
					trackMarketingEvent('cta_click', 'reviews_price')
					navigate(withLang(lang, '/price'))
				}} />
			</div>
		</section>
	)
}

export default Reviews
